import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

// Exporte un élément DOM en PDF A4 (pagination automatique si plus haut qu'une page).
export async function downloadElementPdf(el, filename = "document.pdf") {
  if (!el) return;
  const canvas = await html2canvas(el, { scale: 2, useCORS: true, backgroundColor: "#ffffff" });
  const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
  const pw = pdf.internal.pageSize.getWidth();
  const ph = pdf.internal.pageSize.getHeight();
  const imgW = pw;
  const imgH = (canvas.height * imgW) / canvas.width;
  const data = canvas.toDataURL("image/png");
  let heightLeft = imgH;
  let position = 0;
  pdf.addImage(data, "PNG", 0, position, imgW, imgH);
  heightLeft -= ph;
  while (heightLeft > 0) {
    position -= ph;
    pdf.addPage();
    pdf.addImage(data, "PNG", 0, position, imgW, imgH);
    heightLeft -= ph;
  }
  pdf.save(filename);
}
